import { useEffect, useState } from 'react'
import useOverlay from '../../hooks/useOverlay.js'
import { Dialog } from '../Dialog/index.js'
import { Stack } from '../Stack/index.js'
import { Button } from '../Button/index.js'
import { useClient } from '@based/sdk/react'
import { useUser } from '../../hooks/useUser.js'
import { CheckboxInput } from '../CheckboxInput/index.js'
import { useToast } from '../Toast/index.js'
import { registerPasskey } from './registerPasskey.js'

export const PasskeysReminder = () => {
  const user = useUser()
  const client = useClient()
  const toast = useToast()
  const [dontRemindMeAgain, setDontRemindMeAgain] = useState(false)

  const registerPasskeyDialog = useOverlay(Dialog, {
    title: 'Register passkey?',
    description:
      'Passkeys speed up your login process and make your account more secure.',
    children: (
      <>
        <Stack justify="start">
          <CheckboxInput
            value={dontRemindMeAgain}
            onChange={() => {
              setDontRemindMeAgain(!dontRemindMeAgain)
            }}
            description="Don't remind me again"
          />
        </Stack>
        <Stack gap={16}>
          <Button
            keyHint="Esc"
            variant="border"
            onClick={async () => {
              await client.call('ui-account-settings-update', {
                passkeysReminder: dontRemindMeAgain
                  ? 8640000000000000 // far far in the future
                  : Date.now() + 7 * 24 * 60 * 60 * 1000, // one week
              })
              Dialog.Close()
            }}
            width="full"
            align="center"
          >
            Cancel
          </Button>
          <Button
            keyHint="Enter"
            width="full"
            align="center"
            onClick={async () => {
              try {
                const res = await registerPasskey({ client, toast, Dialog })
                if (res.ok) {
                  toast('Passkey registered', {
                    icon: 'checkmark-filled',
                  })
                  Dialog.Close()
                }
              } catch (error) {
                toast('Error registering passkey', {
                  description:
                    error instanceof Error ? error.message : String(error),
                  icon: 'error-filled',
                  color: 'red',
                })
                Dialog.Close()
                return
              }
            }}
          >
            Register
          </Button>
        </Stack>
      </>
    ),
  })
  useEffect(() => {
    if (
      user?.id &&
      user.status !== 'onboarding' &&
      !user.passkeys?.length &&
      user.passkeysReminder < Date.now()
    ) {
      registerPasskeyDialog()
    }
  }, [])
  return null
}
